import product1 from '../../images/tiramisu.jpg';
import product2 from '../../images/pavlova.jpg';
import product3 from '../../images/Macarons.jpg';
import product4 from '../../images/cheesecake.jpg';
import product5 from '../../images/donuts.jpg';
import product6 from '../../images/brownies.jpg';
import drinks1 from '../../images/iced-coffee.jpg';
import drinks2 from '../../images/marshcoffee.jpg';
import drinks3 from '../../images/lemonade.jpg';
import drinks4 from '../../images/coffee.jpg';
import drinks5 from '../../images/shakes.jpg';
import drinks6 from '../../images/smoothie.jpg';
import icecream1 from '../../images/sweet3.jpg';
import icecream2 from '../../images/sweet3.jpg';
import icecream3 from '../../images/sweet3.jpg';
import icecream4 from '../../images/sweet3.jpg';
import icecream5 from '../../images/sweet3.jpg';
import icecream6 from '../../images/sweet3.jpg';

export const productData = [
  {
    img: product1,
    alt: 'Tiramisu',
    name: 'Tiramisu',
    desc:
      'Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto',
    price: '$19.99',
    button: 'Add to Cart'
  },
  {
    img: product2,
    alt: 'Pavlova',
    name: 'Pavlova',
    desc:
      ' Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto',
    price: '$16.99',
    button: 'Add to Cart'
  },
  {
    img: product3,
    alt: 'Macarons',
    name: 'Macarons',
    desc:
      ' Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto',
    price: '$14.99',
    button: 'Add to Cart'
  },
  {
    img: product4,
    alt: 'Cheesecake',
    name: 'Cheesecake',
    desc:
      ' Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto',
    price: '$14.99',
    button: 'Add to Cart'
  },
  {
    img: product5,
    alt: 'Donuts',
    name: 'Donuts',
    desc:
      ' Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto',
    price: '$14.99',
    button: 'Add to Cart'
  },
  {
    img: product6,
    alt: 'Brownies',
    name: 'Brownies',
    desc:
      ' Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto',
    price: '$14.99',
    button: 'Add to Cart'
  }
];

export const productDataTwo = [
  {
    img: drinks1,
    alt: 'Iced coffee',
    name: 'Iced coffee',
    price: '$9.99',
    button: 'Add to Cart'
  },
  {
    img: drinks2,
    alt: 'Marshcoffee',
    name: 'Marshcoffee',
    price: '$12.99',
    button: 'Add to Cart'
  },
  {
    img: drinks3,
    alt: 'Lemonade',
    name: 'Lemonade',
    price: '$9.99',
    button: 'Add to Cart'
  },
  {
    img: drinks4,
    alt: 'Coffee',
    name: 'Coffee',
    price: '$9.99',
    button: 'Add to Cart'
  },
  {
    img: drinks5,
    alt: 'Shakes',
    name: 'Shakes',
    price: '$9.99',
    button: 'Add to Cart'
  },
  {
    img: drinks6,
    alt: 'Smoothie',
    name: 'Smoothie',
    price: '$9.99',
    button: 'Add to Cart'
  }
];

export const productDataThree = [
  {
    img: icecream1,
    alt: 'Sundae',
    name: 'Sundae',
    desc:
      'Belgian chocolate glazed donuts covered in icing with sprinkles on top',
    price: '$9.99',
    button: 'Add to Cart'
  },
  {
    img: icecream2,
    alt: 'Banana split',
    name: 'Banana split',
    desc:
      'Vanilla ice cream covered with caramel and chocolate glaze topped with a coco stick',
    price: '$12.99',
    button: 'Add to Cart'
  },
  {
    img: icecream3,
    alt: 'Fried Ice',
    name: 'Fried Ice',
    desc:
      'Double fudge brownie squares topped with white chocolate pieces and macadamia nuts',
    price: '$9.99',
    button: 'Add to Cart'
  },
  {
    img: icecream4,
    alt: 'Yogurt',
    name: 'Yogurt',
    desc:
      'Double fudge brownie squares topped with white chocolate pieces and macadamia nuts',
    price: '$9.99',
    button: 'Add to Cart'
  },
  {
    img: icecream5,
    alt: 'Slushies',
    name: 'Slushies',
    desc:
      'Double fudge brownie squares topped with white chocolate pieces and macadamia nuts',
    price: '$9.99',
    button: 'Add to Cart'
  },
  {
    img: icecream6,
    alt: 'Ice cream sandwich',
    name: 'Ice cream sandwich',
    desc:
      'Double fudge brownie squares topped with white chocolate pieces and macadamia nuts',
    price: '$9.99',
    button: 'Add to Cart'
  }
];
